import {Funcionario} from 'src/app/core/funcionario';
import {FrequenciaAcao} from "./frequencias_acoes";
import {ColaboradorAcao} from "./colaboradores_acoes";
import {MetaAcaoExecutada} from "./meta-acao-executada";
import {Acoes} from "./acoes";

export class AcaoExecutada {
    id: number;
    idAcao: number;
    acao: Acoes;
    descricao: string;
    descricaoMetodologia: string;
    descricaoOcorrencia: string;
    descricaoAvaliacao: string;
    funcionarioResponsavel: Funcionario;
    dataInicio: Date;
    dataFim: Date;
    horaInicio: string;
    horaFim: string;
    qtdParticipantes: number;

    frequencias: FrequenciaAcao[];
    colaboradores: ColaboradorAcao[];
    metas: MetaAcaoExecutada[];
}